import type { Tag } from "~/common/interfaces/entities/tag.interface";

export const getTagDefault = (): Tag => ({
	id: 0,
	name: "",
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString()
});
